require('./bootstrap');
require("flatpickr");
require("flatpickr/dist/l10n/ro.js").default.ro;